import Flex from "@/components/flex"
import { TrendingUp, TrendingDown } from "lucide-react"
import { langStore } from "@/stores/lang-store"
import AnimatedNumber from "./animated-number"
import { kpiMetricCompareBundle } from "./kpi-metric-const"
import Wrapper from "@/components/wrapper"

const KpiMetricCard = ({ item, period }) => {
  const { lang } = langStore()

  const previousLabel =
    period === "today" ? "yesterday" : period === "7days" ? "previousWeek" : "previousMonth"

  const is_up = period === "today" ? item.hourly?.is_up : item.is_up
  const diff = period === "today" ? item.hourly?.diff : item.diff

  return (
    <Wrapper.shadow className="p-5 pb-3 flex flex-col gap-4 bg-white rounded-2xl min-h-30">
      <Flex className="justify-between items-start">
        <Flex className="flex-col" gap={4}>
          <p className="text-sm text-gray-500 font-medium">{item.label[lang]}</p>

          <h2 className="text-2xl font-bold text-gray-800 flex items-end gap-1">
            <AnimatedNumber value={item.value} decimals={1} />
            <span className="text-sm text-gray-500 mb-1">{item.unit}</span>
          </h2>
        </Flex>

        <Flex className={`w-12 h-12 rounded-xl items-center justify-center ${item.iconBg}`}>
          <img src={item.imgSrc} alt={item.label[lang]} className="w-7 h-7 object-contain" />
        </Flex>
      </Flex>

      <Flex className="items-end justify-start text-xs">
        <article className="min-w-15">
          <p className="text-gray-400">{kpiMetricCompareBundle[previousLabel][lang]}</p>

          <p className="font-semibold text-gray-600 whitespace-nowrap">
            {(period === "today"
              ? item.hourly?.previous_value
              : item.previous_value
            )?.toLocaleString()}{" "}
            <span className="font-normal text-gray-400">{item.unit}</span>
          </p>
        </article>

        {period === "today" && (
          <article>
            <p className="text-gray-400">{kpiMetricCompareBundle.currentHour[lang]}</p>

            <p className="font-semibold text-gray-600 whitespace-nowrap">
              {item.hourly?.value?.toLocaleString()}{" "}
              <span className="font-normal text-gray-400">{item.unit}</span>
            </p>
          </article>
        )}

        <Flex
          className={`ml-auto items-center gap-1 font-bold text-[15px] ${is_up ? "text-red-500" : "text-blue-500"}`}
          gap={4}
        >
          {is_up ? <TrendingUp className="w-5 h-5" /> : <TrendingDown className="w-5 h-5" />}

          <span>{diff}</span>
        </Flex>
      </Flex>
    </Wrapper.shadow>
  )
}

export default KpiMetricCard
